module.exports = __webpack_public_path__ + "media/images/bg-1-c0c8097f9055de0bd74e3a54ea396dfa.jpg";